import { render } from "./OrgProfileOpinionsList.vue?vue&type=template&id=5e0c0941"
import script from "./OrgProfileOpinionsList.vue?vue&type=script&lang=js"
export * from "./OrgProfileOpinionsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__